import { LuxTypography } from 'types/typography';

export const FW_BOLD = 700;
export const FW_SEMI_BOLD = 590;
export const FW_MEDIUM = 500;
export const FW_NORMAL = 400;

const bold = {
  fontWeight: FW_SEMI_BOLD,
};
const medium = {
  fontWeight: FW_MEDIUM,
};
const regular = {
  fontWeight: FW_NORMAL,
};

const display = {
  fontSize: '83px',
  lineHeight: '100px',
};
const titleXl = {
  fontSize: '43px',
  lineHeight: '52px',
  letterSpacing: '-2%',
};
const titleL = {
  fontSize: '34px',
  lineHeight: '44px',
};
const titleM = {
  fontSize: '27px',
  lineHeight: '36px',
};
const titleS = {
  fontSize: '22px',
  lineHeight: '28px',
};
const titleXs = {
  fontSize: '18px',
  lineHeight: '25px',
};
const body = {
  fontSize: '14px',
  lineHeight: '18px',
};
const tooltip = {
  fontSize: '11px',
  lineHeight: '15px',
};
const tag = {
  fontSize: '9px',
  lineHeight: '12px',
};

export const luxTypography: LuxTypography = {
  display_b: {
    ...display,
    ...bold,
  },
  display_m: {
    ...display,
    ...medium,
  },
  display: {
    ...display,
    ...regular,
  },
  titleXl_b: {
    ...titleXl,
    ...bold,
  },
  titleXl_m: {
    ...titleXl,
    ...medium,
  },
  titleXl: {
    ...titleXl,
    ...regular,
  },
  titleL_b: {
    ...titleL,
    ...bold,
  },
  titleL_m: {
    ...titleL,
    ...medium,
  },
  titleL: {
    ...titleL,
    ...regular,
  },
  titleM_b: {
    ...titleM,
    ...bold,
  },
  titleM_m: {
    ...titleM,
    ...medium,
  },
  titleM: {
    ...titleM,
    ...regular,
  },
  titleS_b: {
    ...titleS,
    ...bold,
  },
  titleS_m: {
    ...titleS,
    ...medium,
  },
  titleS: {
    ...titleS,
    ...regular,
  },
  titleXs_b: {
    ...titleXs,
    ...bold,
  },
  titleXs_m: {
    ...titleXs,
    ...medium,
  },
  titleXs: {
    ...titleXs,
    ...regular,
  },
  body_b: {
    ...body,
    ...bold,
  },
  body_m: {
    ...body,
    ...medium,
  },
  body: {
    ...body,
    ...regular,
  },
  tooltip_b: {
    ...tooltip,
    ...bold,
  },
  tooltip_m: {
    ...tooltip,
    ...medium,
  },
  tooltip: {
    ...tooltip,
    ...regular,
  },
  tag_b: {
    ...tag,
    ...bold,
  },
  tag_m: {
    ...tag,
    ...medium,
  },
  tag: {
    ...tag,
    ...regular,
  },
};
